import {
  DefaultModalDialogData
} from "@hub-workspace/apps/hub/src/app/partials/custody-portability/common/default-modal/default-modal-modal.models";

export interface RequestPortabilityDialogs {
  userExpired: DefaultModalDialogData;
  userInValidation: DefaultModalDialogData;
  judicialBlock: DefaultModalDialogData;
  userInFilling: DefaultModalDialogData;
}

export interface IUserRequests {
  requests: IPortabilityRequest[];
}

export interface IPortabilityStatusHistoryItem {
  IdPortabilityRequest: number;
  IdStatus: RequestStatus;
  StatusName: string;
  StatusDate: string;
}

export interface IPortabilityStatusHistoryResponse {
  statusHistory: IPortabilityStatusHistoryItem[];
}

export interface IPortabilityRequest {
  protocol: string;
  origin: {
    brokerName: string;
    accountNumber: string;
  };
  destination: {
    brokerName: string;
    accountNumber: string;
  };
  requestDate: Date;
  deadline?: Date;
  status: RequestStatus;
  extendDate?: Date;
}

export enum RequestStatus {
  ACTION_PENDING = 1,
  RECEIVED = 2,
  AUTHORIZED = 3,
  IN_ANALYSIS = 4,
  IN_PROCESS = 5,
  COMPLETED = 6,
  REFUSED = 7,
  CANCELED = 8,
  UNAUTHORIZED =9,
  AWAITING_COUNTERPARTY_APPROVAL = 10,
  AWAITING_REJECTION_CONFIRMATION = 11,
  AWAITING_EFFECTUATION = 12,
}
